import { WeeklyFocusBlockSummary } from 'interfaces/user.interface';
import { uniqueByKey } from 'utils/unique-by-key.util';

const getFocusSummaryId = (summary: WeeklyFocusBlockSummary): string =>
  summary.id;

export const uniqueFocusSummariesById = (
  summaries: WeeklyFocusBlockSummary[]
): WeeklyFocusBlockSummary[] =>
  uniqueByKey(summaries, getFocusSummaryId);

export const mergeFocusSummariesById = (
  existing: WeeklyFocusBlockSummary[],
  incoming: WeeklyFocusBlockSummary[]
): WeeklyFocusBlockSummary[] =>
  uniqueFocusSummariesById([...existing, ...incoming]);
